module.exports = __webpack_public_path__ + "img/szditu.f115b725.png";